const muiChipTheme = (theme, color) => {
  theme.overrides.MuiChip = {
    root: {
      height: 'auto',
      minHeight: '26px',
      wordBreak: 'break-word',
      marginTop: '2px',
      marginBottom: '4px',
    },
    label: {
      whiteSpace: 'initial',
      paddingTop: '5px',
      paddingBottom: '2px',
    },
    colorPrimary: color,
  };
};

export default muiChipTheme;
